import Vue from 'vue'
import Vuex from 'vuex'
import Fun from '@/assets/js/index.js';// 公共方法

Vue.use(Vuex)
//公共方法
// Vue.mixin(Fun);
const store = new Vuex.Store({
  state: {
    token:Fun.methods.local_getItem("token")||'',
    userInfo:JSON.parse(Fun.methods.local_getItem("user")||'{}'),
  },
  mutations: {
    setUserInfo(state,value){
      if(value){
        state.userInfo=value;
        state.token=value.token
        Fun.methods.local_setItem("user",JSON.stringify(value));
      }else{
        state.userInfo='';
        state.token='';
        localStorage.removeItem("user");
        localStorage.removeItem("token");
      }
    },
    setUserImg(state,value){
      if(value){
        state.userInfo.realFilePath=value;
        Fun.methods.local_setItem("user",JSON.stringify(state.userInfo));
      }
    }
  }
})
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js